export const SupportedTextCharset = ['utf-8', 'shift_jis'] as const
export type CsvCharset = (typeof SupportedTextCharset)[number]
